import { ForwardedRef, useRef, useState, forwardRef, useImperativeHandle } from "react"
import { Price } from "../../models/Price"
import { ESectors, Sectors, TSectorPair } from "../../shared/Consts"
import Dropdown, { IDropdown } from "../../gui/Dropdown/Dropdown"
import TextInput, { Evaluators, ITextInput } from "../../gui/TextInput/TextInput"
import IconButton from "../../gui/Button/IconButton"
import AddIcon from "../../gui/Icons/AddIcon"
import SectorRow from "./SectorRow"
import _ from "lodash"

export type TSectorEditorProps = {
    price:Price
}
export interface ISectorEditor {
    sector:ESectors
    sectors:TSectorPair[]|null
}
export default forwardRef((props:TSectorEditorProps, ref?:ForwardedRef<ISectorEditor>) => {
    const [dist,setDist] = useState<TSectorPair[]>(props.price.sector!=ESectors.Mixed ? [[props.price.sector,1]] : props.price.sectors ?? [])
    const refSector = useRef<IDropdown<ESectors>|null>(null)
    const refPercent = useRef<ITextInput|null>(null)
    const onAdd = () => setDist((dist:TSectorPair[]) => {
        const sector = refSector.current!.value!
        const percent :number = (Number(refPercent.current?.value||"") ?? 0)/100
        return [...dist,[sector, percent]]
    })

    const filteredSectors = Sectors.filter(s => s.id>=0 && !dist.find(d=>d[0]==s.id))
    const onUpdate = (sector:ESectors,percent:number) => setDist((dist:TSectorPair[]) => {
        const index = dist.findIndex(d => d[0]==sector)
        if (index>=0) dist[index] = [sector,percent]
        return [...dist]
    })
    const onDelete= (sector:ESectors) => setDist((dist:TSectorPair[]) => {
        _.remove(dist, d => d[0]==sector)
        return [...dist]
    })
    useImperativeHandle(ref, () => ({
        get sector() {
            if (dist.length==0) return ESectors.Cash
            else if (dist.length==1) return dist[0][0]
            else return ESectors.Mixed
        },
        get sectors() {
            if (dist.length>1) return dist
            else return null
        }
    }), [dist])
    const rows = dist.map(row => <SectorRow sector={row[0]} value={row[1]} onUpdate={onUpdate} onDelete={onDelete} key={row[0]}/>)
    return <div id="slist">
        <div className="header flex middle gap-8">
            <Dropdown ref={refSector} className="flex1" options={filteredSectors} placeholder="Sector" float={true} anchorProps={{width:"match"}}/>
            <TextInput ref={refPercent} placeholder="Holding %" float={true} evaluator={Evaluators.Number}/>
            <IconButton onClick={onAdd}><AddIcon/></IconButton>
        </div>
        <div className="sectors">{rows}</div>
    </div>
})